import { render, staticRenderFns } from "./create-purchase.vue?vue&type=template&id=12033e0c&scoped=true"
import script from "./create-purchase.vue?vue&type=script&lang=js"
export * from "./create-purchase.vue?vue&type=script&lang=js"
import style0 from "./create-purchase.vue?vue&type=style&index=0&id=12033e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12033e0c",
  null
  
)

export default component.exports